import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import moment from "moment";
import Select from "react-select";
import { startCase } from "lodash";

import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { formatDate, toFixedWithoutRounding } from "../../utils/constants";

const platformOptions = [
  { value: "ACEWIN", label: "ACEWIN" },
  { value: "AVIATOR", label: "AVIATOR" },
  { value: "BG", label: "BG" },
  { value: "BTG", label: "BTG" },
  { value: "CG", label: "CG" },
  { value: "COMBO", label: "COMBO" },
  { value: "CQ9", label: "CQ9" },
  { value: "CRASH88", label: "CRASH88" },
  { value: "CREEDROOMZ", label: "CREEDROOMZ" },
  { value: "DRAGOONSOFT", label: "DRAGOONSOFT" },
  { value: "DREAMGAMING", label: "DREAMGAMING" },
  { value: "E1SPORT", label: "E1SPORT" },
  { value: "EVOLUTION", label: "EVOLUTION" },
  { value: "FASTSPIN", label: "FASTSPIN" },
  { value: "FBSPORTS", label: "FBSPORTS" },
  { value: "FC", label: "FC" },
  { value: "FIVEG", label: "FIVEG" },
  { value: "GOGOLI", label: "GOGOLI" },
  { value: "GTF", label: "GTF" },
  { value: "HABANERO", label: "HABANERO" },
  { value: "HACKSAW", label: "HACKSAW" },
  { value: "HORSEBOOK", label: "HORSEBOOK" },
  { value: "HOTROAD", label: "HOTROAD" },
  { value: "JDB", label: "JDB" },
  { value: "JILI", label: "JILI" },
  { value: "JOKER", label: "JOKER" },
  { value: "KINGMAKER", label: "KINGMAKER" },
  { value: "LUCKY365", label: "LUCKY365" },
  { value: "LUCKYPOKER", label: "LUCKYPOKER" },
  { value: "LUDO", label: "LUDO" },
  { value: "MAC88", label: "MAC88" },
  { value: "MG", label: "MG" },
  { value: "MICROSLOT", label: "MICROSLOT" },
  { value: "MIMI", label: "MIMI" },
  { value: "MT", label: "MT" },
  { value: "NETENT", label: "NETENT" },
  { value: "NEXTSPIN", label: "NEXTSPIN" },
  { value: "NLC", label: "NLC" },
  { value: "OCTOPLAY", label: "OCTOPLAY" },
  { value: "PENGUINKING", label: "PENGUINKING" },
  { value: "PG", label: "PG" },
  { value: "PINNACLE", label: "PINNACLE" },
  { value: "PLAY8", label: "PLAY8" },
  { value: "PLAYNGO", label: "PLAYNGO" },
  { value: "PLAYTECH", label: "PLAYTECH" },
  { value: "PP", label: "PP" },
  { value: "RELAX", label: "RELAX" },
  { value: "ROYALGAMING", label: "ROYALGAMING" },
  { value: "RT", label: "RT" },
  { value: "SABA", label: "SABA" },
  { value: "SEXYBCRT", label: "SEXYBCRT" },
  { value: "SMARTSOFT", label: "SMARTSOFT" },
  { value: "SPADE", label: "SPADE" },
  { value: "SPRIBE", label: "SPRIBE" },
  { value: "SV388", label: "SV388" },
  { value: "TADA", label: "TADA" },
  { value: "VIACASINO", label: "VIACASINO" },
  { value: "VRLOTTO", label: "VRLOTTO" },
  { value: "WINFINITY", label: "WINFINITY" },
  { value: "YESBINGO", label: "YESBINGO" },
  { value: "YGGDRASIL", label: "YGGDRASIL" },
  { value: "YL", label: "YL" },
];

const CasinoBetList = () => {
  const DEFAULT_FILTER = {
    platform: "",
    type: "3",
    betType: "casino",
    sortOrder: "asc",
    fromPeriod: moment().subtract(1, "day").format("YYYY-MM-DD"),
    toPeriod: moment().format("YYYY-MM-DD"),
    casionType: -1,
    betId: "",
    stake: "",
    gameName: "",
    limit: 25,
    status: "completed",
    page: 1,
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [data, setData] = useState({});
console.log(filter,"filter");
  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getCasinoNew,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      setData(response_users.results || {});
    }
  };

  useEffect(() => {
    getData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  const handleSortChange = (e) =>
    setFilter((prev) => ({ ...prev, status: e.target.value, page: 1 }));
  const handleBetIdChange = (e) =>
    setFilter((prev) => ({ ...prev, betId: e.target.value }));
  const handleStakeChange = (e) =>
    setFilter((prev) => ({ ...prev, stake: e.target.value }));
  const handleGameNameChange = (e) =>
    setFilter((prev) => ({ ...prev, gameName: e.target.value }));
  const handleFromChange = (e) =>
    setFilter((prev) => ({ ...prev, fromPeriod: e.target.value }));
  const handleToChange = (e) =>
    setFilter((prev) => ({ ...prev, toPeriod: e.target.value }));
    const handlePlateformChange = (option) => {
  setFilter((prev) => ({
    ...prev,
    platform: option?.value || "",
  }));
};

  const applyPreset = (preset) => {
    const nextFilter = {
      ...filter,
      page: 1,
      fromPeriod:
        preset === "today"
          ? moment().format("YYYY-MM-DD")
          : moment().subtract(1, "day").format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    };
    setFilter(nextFilter);
    getData(nextFilter);
  };

  const handlePageChange = (newPage) => {
    const nextFilter = { ...filter, page: newPage };
    setFilter(nextFilter);
    getData(nextFilter);
  };

  const rows = data?.data || [];
  const totalPnl = rows.reduce(
    (sum, item) => sum + Number(item?.playerPL ?? item?.amount ?? 0),
    0,
  );
  const totalStakes = rows.reduce(
    (sum, item) => sum + Number(item?.betAmount || 0),
    0,
  );

  return (
    <div>
      <div className="user_data_div p-1">
        <section className="main-inner-outer py-3">
          <Container fluid>
            <div className="inner-wrapper">
              <div className="common-container">
                <Form className="">
                  <div className="bet_status border-0 mb-0">
                    <div className="d-flex align-items-center flex-wrap mb-2">
                      <strong className="me-auto">Casino Bet List</strong>
                    </div>

                    <Row>
                      <Col lg={2} sm={3} className="mb-lg-0 mb-1">
                        <div className="bet-sec">
                          <Form.Label className="mt-2 me-2">
                            Platform:
                          </Form.Label>
                          <Select
                  options={platformOptions}
                  placeholder="All Platform"
                  isSearchable={true}
                  isClearable={true}
                  className="ng-select ng-select-single ng-select-searchable ng-select-clearable"
                  classNamePrefix="ng"
                   onChange={handlePlateformChange}
                />
                        </div>
                      </Col>
                      <Col lg={2} sm={3} className="mb-lg-0 mb-1">
                        <div className="bet-sec bet-period">
                          <Form.Label className="mt-2 me-2">From</Form.Label>
                          <Form.Group className="form-group">
                            <Form.Control
                              onChange={handleFromChange}
                              max={new Date().toISOString().split("T")[0]}
                              value={filter.fromPeriod}
                              type="date"
                            />
                            <Form.Control
                              className="small_form_control"
                              type="text"
                              placeholder="00:00"
                              disabled
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={2} sm={3} className="mb-lg-0 mb-1">
                        <div className="bet-sec bet-period">
                          <Form.Label className="mt-2 me-2">To</Form.Label>
                          <Form.Group className="form-group">
                            <Form.Control
                              onChange={handleToChange}
                              min={filter.fromPeriod || undefined}
                              disabled={filter.fromPeriod ? false : true}
                              max={new Date().toISOString().split("T")[0]}
                              value={filter.toPeriod}
                              type="date"
                            />
                            <Form.Control
                              className="small_form_control"
                              type="text"
                              placeholder="23:59"
                              disabled
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={2} sm={3} className="mb-lg-0 mb-1">
                        <div className="history-btn mb-3">
                          <ul className="list-unstyled mb-0">
                            <li>
                              <Button
                                className={"me-0 theme_light_btn"}
                                onClick={() => applyPreset("today")}
                              >
                                Just For Today
                              </Button>
                            </li>
                            <li>
                              <Button
                                className={"me-0 theme_light_btn"}
                                onClick={() => applyPreset("yesterday")}
                              >
                                From Yesterday
                              </Button>
                            </li>
                            <li>
                              <Button
                                className="theme_light_btn theme_dark_btn"
                                onClick={() => getData(filter)}
                              >
                                Get History
                              </Button>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col lg={2} sm={3} className="mb-lg-0 mb-1">
                        <div className="bet-sec">
                          <Form.Label className="mt-2 me-2">Limit:</Form.Label>
                          <Form.Select
                            className="small_select"
                            value={filter.limit}
                            onChange={handleLimitChange}
                          >
                            <option value={10}>10 Txn</option>
                            <option value={25}>25 Txn</option>
                            <option value={50}>50 Txn</option>
                            <option value={100}>100 Txn</option>
                          </Form.Select>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Form>

                <div className="account-table account-tabel-style batting-table">
                  <div className="responsive">
                    <Table>
                      <thead>
                        <tr>
                          <th scope="col">SA ID</th>
                          <th scope="col">SM ID</th>
                          <th scope="col">MA ID</th>
                          <th scope="col">PL ID</th>
                          <th scope="col">Round Id</th>
                          <th scope="col">Bet taken</th>
                          <th scope="col">Game Code</th>
                          <th scope="col">Platform</th>
                          <th scope="col">Game Name</th>
                          <th scope="col">Stake</th>
                          <th scope="col">Profit/Loss</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.length > 0 ? (
                          rows.map((item, index) => {
                            const pl = Number(
                              item?.playerPL ?? item?.amount ?? 0,
                            );
                            return (
                              <tr key={item?._id || index}>
                                <td>{item?.superAdmin?.username || "-"}</td>
                                <td>{item?.superMaster?.username || "-"}</td>
                                <td>{item?.master?.username || "-"}</td>
                                <td>{item?.clientName || "-"}</td>
                                <td
                                  style={{
                                    textDecoration: "underline",
                                    color: "#2779bf",
                                  }}
                                >
                                  {item?.casinoBetId || "-"}
                                </td>
                                <td>{formatDate(item?.timeInserted)}</td>
                                <td>{item?.gameCode || "-"}</td>
                                <td>{item?.platform}</td>
                                <td>{item?.casinoName}</td>
                                <td>
                                  {toFixedWithoutRounding(item?.betAmount || 0)}
                                </td>
                                <td>
                                  <span
                                    style={{ background: "transparent" }}
                                    className={
                                      pl === 0
                                        ? ""
                                        : pl < 0
                                          ? "text-danger"
                                          : "text-success"
                                    }
                                  >
                                    {toFixedWithoutRounding(pl)}
                                  </span>
                                </td>
                                <td>
                                  {item?.status ? startCase(item.status) : "-"}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={12}>
                              <span>You have no bets in this time period.</span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      forcePage={filter.page ? filter.page - 1 : 0}
                      onPageChange={(event) =>
                        handlePageChange(event.selected + 1)
                      }
                      pageRangeDisplayed={10}
                      pageCount={data?.totalPages || 0}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      activeClassName="p-1"
                      activeLinkClassName="pagintion-li"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </div>
  );
};

export default CasinoBetList;
